import { LicenseType } from '../index'

const map = {
  '0': {
    limit: Infinity,
    name: '50+',
  },
  '1': {
    limit: 3,
    name: '1-3',
  },
  '2': {
    limit: 10,
    name: '4-10',
  },
  '3': {
    limit: 20,
    name: '11-20',
  },
  '4': {
    limit: 50,
    name: '21-50',
  },
  '5': {
    limit: Infinity,
    name: '50+',
  },
  '9999': {
    limit: Infinity,
    name: '50+',
  },
  default: {
    limit: Infinity,
    name: '',
  },
}

const mapRoomsLimitToNumbers = (
  type: string,
  licenseType: LicenseType = LicenseType.LICENSE_WEB_ANDROID,
  userPriceGroup
) => {
  if (!type) return map.default;

  if (
    [
      LicenseType.LICENSE_PREMIUM_ROOMS,
      LicenseType.LICENSE_PREMIUM_BASIC,
      LicenseType.LICENSE_PREMIUM_ASSISTENT,
      LicenseType.LICENSE_PREMIUM_PROFESSIONAL,
    ].includes(licenseType) && +userPriceGroup !== 3
  ) {
    return map[+type > 5 ? '9999' : type];
  }

  if (
    [
      LicenseType.LICENSE_PREMIUM_LITE,
      LicenseType.LICENSE_PREMIUM_PLUS,
      LicenseType.LICENSE_PREMIUM_PRO,
      LicenseType.LICENSE_PREMIUM_MAX,
    ].includes(licenseType) && userPriceGroup === '3'
  ) {
    return Number(type) === 9999 ? map['9999'] : { limit: type, name: type };
  }

  return map[type] || map.default;
};

export default mapRoomsLimitToNumbers
